import { useDashboardSideModal } from 'components/content/dashboardSideModal/utils'
import { useInsideDirectiveActions } from 'components/directive/utils/directiveUtils'
import { DirectiveType } from 'components/directive/utils/types'
import { useTranslation } from 'next-i18next'
import { useMemo, useState } from 'react'

export const useDirectiveActionsWithInfoModal = () => {
  const { t } = useTranslation()
  const [currentDirective, setCurrentDirective] = useState<DirectiveType>('WILL')
  const [directiveModal, openDirectiveModal] = useDashboardSideModal(currentDirective)
  const actions = useInsideDirectiveActions()

  const actionsWithInfoModal = useMemo(
    () =>
      actions.map((action) => ({
        ...action,
        duration: undefined,
        buttonText: t('common.start_now'),
        onInfoClick: () => {
          if (!action.type) return

          setCurrentDirective(action.type)
          openDirectiveModal()
        },
      })),
    [openDirectiveModal, actions, t]
  )

  return [actionsWithInfoModal, directiveModal] as const
}
